import CompaniesLayout from './CompaniesDetailsLayout';

export default CompaniesLayout;
